import { connect } from 'react-redux'
import { makeLogicNodeSelector } from 'selectors/feature/logicNodes'
import { makeLogicSetSimulationsSelector } from 'selectors/feature/simulation'
import TimerBoxSimulator from './TimerBoxSimulator'

const makeMapStateToProps = () => {
  const querySelector = makeLogicNodeSelector()
  const simulationsSelector = makeLogicSetSimulationsSelector()
  const mapStateToProps = (state, ownProps) => {
    const { uri } = ownProps
    const query = querySelector(state, { queryUri: uri })
    const sims = simulationsSelector(state, { queryUri: uri })
    const { description, conditions, timerMode, initialValue } = query || {}

    return {
      ...ownProps,
      description,
      conditions,
      timerMode,
      initialValue,
      ...sims,
    }
  }
  return mapStateToProps
}

const connected = connect(makeMapStateToProps)(TimerBoxSimulator)

export default connected
